import { FC, PropsWithChildren } from "react";
import { Box } from "@chakra-ui/react";

type Props = {
  isInDrawer?: boolean;
};

const MenuLink: FC<PropsWithChildren<Props>> = ({ isInDrawer, children }) => (
  <Box
    display="flex"
    alignItems="center"
    whiteSpace="nowrap"
    textAlign="center"
    w={isInDrawer ? "100%" : "auto"}
    px={isInDrawer ? 0 : "15px"}
    py={isInDrawer ? 4 : "6px"}
    _hover={{
      textDecoration: "underline",
    }}
  >
    {children}
  </Box>
);

export default MenuLink;
